import React, { useContext, useState } from "react";
import {
    Box, Button, Container, Grid,
} from "@mui/material";
import Layout from "components/layout/layout";
import { useNavigate, useParams } from "react-router-dom";

import { ReactComponent as GrantVestmentsIcon } from "./../../assets/Icons/Gantvestments.svg";
import { ReactComponent as ExtendedIcon } from './../../assets/Icons/extended.svg'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import CloseIcon from '@mui/icons-material/Close';
import { TransactionDetailsItem } from "components/transaction-details/transaction-details-item";
import { TransactionDetailsCard } from "components/transaction-details/transaction-details";
import { shortFormat } from "utils/date-format";
import { useCancelGrantVestmentRequestMutation, useGetGrantVestmentRequestQuery } from "hooks/use-services/grant-vestment.service";
import { GRANT_VESTMENT_REQUEST_STATUS_ENUM } from "types/grant-vestment";
import { primary } from "style/color";
import { BackToPreviousButton } from "components/shared/back-to-previous-button";
import { AuthContext } from "providers/userProvider";
import { USER_ROLE } from "types/account";
import { AuthData } from "types/auth";
import { CancelGrantVestmentRequest } from "./cancel-grant-vestment-request";
export const GrantVestmentDetailsPage = () => {
    const { id } = useParams();
    const { userRole } = useContext<AuthData>(AuthContext);
    const navigate = useNavigate();
    const [openCancelDialog, setOpenCancelDialog] = useState<boolean>(false);
    const { mutate: cancelGrantVestmentRequest } =
        useCancelGrantVestmentRequestMutation(
            (id) ? +id : 0
        );
    const { data: grantVestmentRequest, isSuccess } = useGetGrantVestmentRequestQuery((id) ? +id : 0)
    const getStatusCard = () => {
        if (grantVestmentRequest?.status === GRANT_VESTMENT_REQUEST_STATUS_ENUM.PENDING) {
            return {
                icon: <ExtendedIcon />, title: 'Pending', text: 'Transactions appear pending until they are approved and executed.'
            }
        }
        if (grantVestmentRequest?.status === GRANT_VESTMENT_REQUEST_STATUS_ENUM.REJECTED) {
            return {
                icon: <HighlightOffIcon sx={{ color: primary[500] }} />, title: 'Rejected', text: `Our team didn’t approve this transaction due to ${grantVestmentRequest.rejectionReason}`
            }
        }
        return undefined;
    };
    const cancelRequest = (id: number) => {
        cancelGrantVestmentRequest(id, {
            onSuccess: () => {
                navigate(-1);
            },
        });
    };
    return (
        <Layout>
            {() => (
                <>
                    <Box sx={{ my: 4, width: "100%" }}>
                        <React.Fragment>
                            <Container >
                                {
                                    isSuccess && grantVestmentRequest &&
                                    <Grid sx={{ m: 5 }} container spacing={2}>
                                        <Grid item xs={12} sm={9}>
                                            <BackToPreviousButton />
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <TransactionDetailsCard
                                                amount={grantVestmentRequest.appliedAmount}
                                                type="GrantVestment"
                                                title={grantVestmentRequest.grantVestment.name}
                                                avatar={<GrantVestmentsIcon />}
                                                status={grantVestmentRequest.status}
                                                statusCard={getStatusCard()}
                                            >

                                                <TransactionDetailsItem label="Type" value="GrantVestment" />
                                                <TransactionDetailsItem label="Date" value={shortFormat(grantVestmentRequest.executionDate)!} />
                                                <TransactionDetailsItem label="Initiated by" value={`${grantVestmentRequest.user.firstName} ${grantVestmentRequest.user.lastName}`} />
                                                <TransactionDetailsItem label="Fund" value={grantVestmentRequest.fund.fundAccountName} />

                                            </TransactionDetailsCard>

                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            {
                                                grantVestmentRequest.status === GRANT_VESTMENT_REQUEST_STATUS_ENUM.PENDING &&
                                                <>
                                                    <CancelGrantVestmentRequest
                                                        open={openCancelDialog}
                                                        onClose={() => setOpenCancelDialog(false)}
                                                        grantVestmentRequest={grantVestmentRequest!}
                                                        cancelGrantVestmentRequest={cancelRequest!}
                                                    />
                                                    <Button
                                                        disabled={userRole === USER_ROLE.VIEWER} sx={{ mt: 1 }} fullWidth size='large' startIcon={<CloseIcon />} variant='contained' onClick={() => {
                                                            setOpenCancelDialog(true);
                                                        }}>Cancel</Button>
                                                </>

                                            }
                                        </Grid>
                                    </Grid>
                                }


                            </Container>
                        </React.Fragment>
                    </Box>

                </>
            )}
        </Layout>
    );
};
